export const StandingSeatingIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={className}
    >
      <rect width="24" height="24" rx="6" fill="url(#pattern0_10539_2814)" />
      <defs>
        <pattern
          id="pattern0_10539_2814"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_10539_2814"
            transform="translate(-0.0217391) scale(0.0434783)"
          />
        </pattern>
        <image
          id="image0_10539_2814"
          width="24"
          height="23"
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAXCAIAAACeQxh6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAhdJREFUeNqklLGPKVEUxnfXlLxKY16lUbwpdmP/AIka2exbQhRvK9Si9w+IWqgUQqUQtVAphMZ6hWLzNFSym9CYkOwvczfjGuatjVNMztxz73e/7zsn9/rx4ffk7+Tqgthtt3+enxVFcbh+OI/LpVLJ5XIlk8kvgfSNzlexK6uq6nQ6z+dlC5ROp2F0KVA+nw+FQiTD4TCTyZwDdCP/dDqdWq3m8XgECnFvBIutVusbQCJOKlqtVt+QFgwGRdJut01pQORyucVi8X+g69hT7PXf63EBgVCbTqeDwQAs8w4WKbEutz8ajd3Y3QAFsbvX60FQ7gOW+Xy+c9tvBrrkX9CZLzhaJvYEEG1it5278/n85MQqsinISSQS2Wy2UqmUy+VjvwqFQiAQYCUejwsuaHwZv+yB+Ec5dnB+aITMghJAkUhEoAjLw+Gw3++HfvQpugdCCIe5k8tHoxFfGajRaHDTwgizhEZOrddrktvbu4P2Mzs0ReT1eh2BUICm6RdwbACLPhaLRbn9Du2X9vb+JpZwBws/y7rudrtZITGVLpfLfr8/m82q1er+PdrtNE076Bqi0CxyOHe7XRLxleeIPWi0+KiY5qGLM3RU2AF5OohAeYiFZO6zLB50DRXyo5FKpYCeGiEf6BlxPF+fHkEBLc1mExfMCR6Px5zBoy/ebItHcLa8Gydvtn1GvF7vZqNfXRY/VfVDgAEAxhY8FJBqxn4AAAAASUVORK5CYII="
        />
      </defs>
    </svg>
  );
};
